
function isVisible($el) {
  let docViewTop = $(window).scrollTop();
  let docViewBottom = docViewTop + $(window).height();
  let elTop = $el.offset().top;
  let elBottom = elTop + $el.height();
  return((elBottom <= docViewBottom) && (elTop >= docViewTop));
}
var addtocartbtn = document.querySelector(".ajax_sticky_cart");
var findCartBTn = document.querySelector('.product-single__form [data-add-to-cart]');

  addtocartbtn.onclick = function() {
   document.querySelector('[data-add-to-cart]').click();
   addtocartbtn.classList.add('ajax-loader-btn');
   setTimeout(function() {   
     addtocartbtn.classList.remove('ajax-loader-btn');
   },700);
  }


var stickyCart = document.getElementsByClassName('sticky-cart-section')[0];
  stickyCart.style.display = "none";
  var onScroll = () => {
      if(isVisible($(findCartBTn))) {
        stickyCart.style.display = "none";
      }
      else{
          if($('.product-single__form .add-to-cart')[0].getBoundingClientRect().top < 40)
          {
           stickyCart.style.display = "block";
          }
      }
  }
window.addEventListener('scroll', onScroll);

jQuery(document).ready(function() {
	var e = jQuery(".read-more-trigger");
	jQuery(e).on("click", function() {
		jQuery(".hide-content").toggleClass(show), "Read More" == e.text() ? e.text("Read less") : e.text("Read More");
	});
});

// var my_time = new Date();
// alert(my_time);

// Get the currently selected .variant-input
// Get the .variant__label-info span content
// Swap it for the data-value

// Swap out the variant label if there's no stock - find colour and set to label
// jQuery(document).ready(function() {
//   console.log("loaded");
// var e = jQuery(".variant-wrapper .variant-input");
// jQuery(e).on("click", function() {
// 	jQuery(".variant__label-info span").text(jQuery(this).closest(".variant-input").data("value"));
// });
//   jQuery(document).on("click", ".mobile_cart_btn_sticky", function(){
//     jQuery("[data-add-to-cart]").trigger("click");
//   })
// });

  


// New theme and plugin update form to send to Yotpo
$(document).on("swell:setup", function() {
  // Middle of page form
  var middleEmailField = $("#Email-template--16771602874609__6b5f62fe-24a1-49e1-bac8-ad77ecc8f8a2");
  var middleSubmitBtn = $("#newsletter-form-submit-template--16771602874609__6b5f62fe-24a1-49e1-bac8-ad77ecc8f8a2");

  middleSubmitBtn.click(function() {
	var email = middleEmailField.val();
	swellAPI.captureNewsletterSignup(email);
  });

  // Footer form
  var footerEmailField = $("#Email-1494292487693");
  var footerSubmitBtn = $("#newsletter-submit-1494292487693");

  footerSubmitBtn.click(function() {
	var email = footerEmailField.val();
	swellAPI.captureNewsletterSignup(email);
  });

  // Product form
  var productEmailField = $("#Email-template--16771603202289__5be022f6-1fee-418d-8ad5-21116d88e85c");
  var productSubmitBtn = $("#newsletter-form-submit-template--16771603202289__5be022f6-1fee-418d-8ad5-21116d88e85c");

  productSubmitBtn.click(function() {
	var email = productEmailField.val();
	swellAPI.captureNewsletterSignup(email);
  });
});

// Attach once to handle all esp:captured:email events
$(document).on("swell:setup", function() {
  $(document).on("esp:captured:email", function(e, email) {
	swellAPI.captureNewsletterSignup(email);
  });
});